import { CardFlat } from 'core/entities/flats';

import { useGroupedByCityFlats } from 'hooks/flat';

import { FlatListGroup, FlatListGroupPageType } from 'components/flat/flat-list-grouped-by-city/flat-list-group';

interface StarredGroupsProps {
  className?: string;
  mainHost: string;
  flats: Array<CardFlat>;
  flatListGroupPage: FlatListGroupPageType;
  isMobileDevice: boolean;
  starredIdList?: Array<number>;
  hasMaskWhenRemove?: boolean;
}

export const FlatListGroupedByCity = (props: StarredGroupsProps) => {
  const groups = useGroupedByCityFlats(props.flats);
  return (
    <ul className={props.className}>
      {groups.map((group) => (
        <FlatListGroup
          key={group.key}
          mainHost={props.mainHost}
          group={group}
          flatListGroupPage={props.flatListGroupPage}
          isMobile={props.isMobileDevice}
          starredIdList={props.starredIdList}
          hasMaskWhenRemove={props.hasMaskWhenRemove}
        />
      ))}
    </ul>
  );
};
